"use strict";
// import { ButtonControl, FileInputControl, LabelControl, TextInputControl } from "doshx_controls_web";
// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { AppDispatch } from "../store";
// import { setDrawer, setMessageModal } from "../reducers/slices/main";
// import { register_bidder } from "../api/calls/bidder/register_bidder";
// import { IAuctionSliceState } from "../reducers/slices/auction";
// import { setIsBidderRegistered } from "../reducers/slices/bidder";
// import { IUserSliceState } from "../reducers/slices/user";
// import { upload_file } from "../api/calls/upload_file";
// import { parseJwt } from "../helpers/parseJwt";
// import { faLeft } from "@fortawesome/pro-solid-svg-icons";
// import { AuctionRulesConditionsPage } from "../screens/pages/sign_up/auction_rules_conditions";
// import { auctions_for_client } from "../api/calls/auction/auctions_for_client";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterBidderComponent = void 0;
// export const RegisterBidderComponent = (auctionId:any) => {
//   const dispatch = useDispatch<AppDispatch>();
//   const client_entity_id = parseJwt(process.env.CLIENT_TOKEN)?.entity_id;
//   const { user } = useSelector<any, IUserSliceState>((state: any) => state.userState);
//   const { liveAuction } = useSelector<any, IAuctionSliceState>((state: any) => state.auctionState);
//   const [idNumber, setIDNumber] = useState<string>(user.id_number);
//   const [idNumberMessage, setIDNumberMessage] = useState<string>("");
//   const [address, setAddress] = useState<string>(user.address);
//   const [addressMessage, setAddressMessage] = useState<string>("");
//   const [proofOfID, setProofOfID] = useState<File>();
//   const [proofOfIDMessage, setProofOfIDMessage] = useState<string>("");
//   const [proofOfResidence, setProofOfResidence] = useState<File>();
//   const [proofOfResidenceMessage, setProofOfResidenceMessage] = useState<string>("");
//   const [idUploadProgress, setIDUploadProgress] = useState<number>(0);
//   const [residenceUploadProgress, setResidenceUploadProgress] = useState<number>(0);
//   const [isLoading, setIsLoading] = useState<boolean>(false);
//   const [auc, setAuc] = useState(null)
// useEffect(() => {
//   auctions_for_client({
//     entity_id: client_entity_id,
//     user_entity_id: user?.entity_id,
//   }).then((res) => {
//     setAuc(res?.content)
//   })
// }, [])
//   const validate = () => {
//     let messageCount = 0;
//     setIDNumberMessage("");
//     setAddressMessage("");
//     setProofOfIDMessage("");
//     setProofOfResidenceMessage("");
//     if (!idNumber) {
//       messageCount++;
//       setIDNumberMessage("ID Number is required");
//     }
//     if (!address) {
//       messageCount++;
//       setAddressMessage("Address is required");
//     }
//     if (!proofOfID) {
//       messageCount++;
//       setProofOfIDMessage("Proof of ID is required");
//     }
//     if (!proofOfResidence) {
//       messageCount++;
//       setProofOfResidenceMessage("Proof of Residence is required");
//     }
//     return messageCount === 0 ? true : false;
//   };
//   return (
//     <div className="flex flex-col gap-4 h-full justify-center">
//       <div className="flex">
//         <ButtonControl
//           label="Back"
//           startIcon={faLeft}
//           size="xsmall"
//           backgroundColor="bg-secondary"
//           onClick={() => {
//             dispatch(
//               setDrawer({
//                 open: true,
//                 content: <AuctionRulesConditionsPage />,
//               }),
//             );
//           }}
//         />
//       </div>
//       <div className="flex flex-col gap-2">
//         <LabelControl label="Register to Bid" size="2xlarge" bold textColor="text-black" />
//         <div className="flex flex-col gap-4">
//           <TextInputControl
//             label="ID Number"
//             value={idNumber}
//             onChange={(v) => {
//               setIDNumber(v);
//             }}
//             errorText={idNumberMessage}
//           />
//           <TextInputControl
//             label="Address"
//             value={address}
//             onChange={(v) => {
//               setAddress(v);
//             }}
//             errorText={addressMessage}
//           />
//           <div className="flex flex-col relative">
//             <FileInputControl
//               label="Proof of ID"
//               file={proofOfID}
//               onChange={(v) => {
//                 setProofOfID(v);
//               }}
//               size="medium"
//               errorText={proofOfIDMessage}
//             />
//             {idUploadProgress < 100 && (
//               <div
//                 className="h-2"
//                 style={{
//                   width: `${idUploadProgress}%`,
//                 }}
//               ></div>
//             )}
//           </div>
//           <div className="flex flex-col relative">
//             <FileInputControl
//               label="Proof of Residence"
//               file={proofOfResidence}
//               onChange={(v) => {
//                 setProofOfResidence(v);
//               }}
//               size="medium"
//               errorText={proofOfResidenceMessage}
//             />
//             {residenceUploadProgress < 100 && (
//               <div
//                 className="h-2"
//                 style={{
//                   width: `${residenceUploadProgress}%`,
//                 }}
//               ></div>
//             )}
//           </div>
//         </div>
//       </div>
//       <div className="flex flex-row gap-4 justify-evenly w-full">
//         <div className="flex-1">
//         <ButtonControl
//           label="Complete Registration"
//           loading={isLoading}
//           onClick={() => {
//             if (validate()) {
//               setIsLoading(true);
//               register_bidder({
//                 id_number: idNumber,
//                 address: address,
//                 bidder: {
//                   client_entity_id: client_entity_id,
//                   user_entity_id: user.entity_id,
//                   registered_auction_id:auctionId?.auctionId
//                 },
//               }).then(async (response) => {
//                 setIsLoading(false);
//                 if (response.success) {
//                   setIsLoading(true);
//                   await upload_file({
//                     bidder_entity_id: response.content.entity_id,
//                     type: "Document",
//                     custom_name: "proof_of_id",
//                     file: proofOfID,
//                     uploadProgress: async (percentCompleted) => {
//                       setIDUploadProgress(percentCompleted);
//                     },
//                   }).then((response) => {
//                     setIsLoading(false);
//                     console.log("response", response);
//                     if (response.success) {
//                       //
//                     } else {
//                       dispatch(setMessageModal({ title: "Something went wrong while uploading Proof of ID!", messages: [response.data.message] }));
//                     }
//                   });
//                   setIsLoading(true);
//                   await upload_file({
//                     bidder_entity_id: response.content.entity_id,
//                     type: "Document",
//                     custom_name: "proof_of_address",
//                     file: proofOfResidence,
//                     uploadProgress: async (percentCompleted) => {
//                       setIDUploadProgress(percentCompleted);
//                     },
//                   }).then((response) => {
//                     setIsLoading(false);
//                     console.log("response", response);
//                     if (response.success) {
//                       //
//                     } else {
//                       dispatch(setMessageModal({ title: "Something went wrong while uploading Proof of Address!", messages: [response.data.message] }));
//                     }
//                   });
//                   dispatch(setIsBidderRegistered(true));
//                   dispatch(
//                     setDrawer({
//                       open: false,
//                     }),
//                   );
//                   window.location.reload();
//                 } else {
//                   dispatch(setMessageModal({ title: "Something went wrong while saving details!", messages: [response.message] }));
//                 }
//               });
//             }
//           }}
//           backgroundColor="bg-primary"
//         />
//         </div>
//       </div>
//     </div>
//   );
// };
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var main_1 = require("../reducers/slices/main");
var register_bidder_1 = require("../api/calls/bidder/register_bidder");
var auction_1 = require("../reducers/slices/auction");
var bidder_1 = require("../reducers/slices/bidder");
var user_1 = require("../reducers/slices/user");
var upload_file_1 = require("../api/calls/upload_file");
var parseJwt_1 = require("../helpers/parseJwt");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var auction_rules_conditions_1 = require("../screens/pages/sign_up/auction_rules_conditions");
var auctions_for_client_1 = require("../api/calls/auction/auctions_for_client");
var local_storage_names_1 = require("../constants/local_storage_names");
var sign_in_1 = require("../api/calls/user/sign_in");
var bidder_status_1 = require("../api/calls/bidder/bidder_status");
var sign_up_1 = require("../api/calls/user/sign_up");
var get_auction_1 = require("../api/calls/auction/get_auction");
var RegisterBidderComponent = function (auctionId) {
    var _a, _b, _c;
    var dispatch = (0, react_redux_1.useDispatch)();
    var client_entity_id = (_a = (0, parseJwt_1.parseJwt)(process.env.CLIENT_TOKEN)) === null || _a === void 0 ? void 0 : _a.entity_id;
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var liveAuction = (0, react_redux_1.useSelector)(function (state) { return state.auctionState; }).liveAuction;
    var _d = (0, react_1.useState)(user.id_number), idNumber = _d[0], setIDNumber = _d[1];
    var _e = (0, react_1.useState)(user.email), email = _e[0], setEmail = _e[1];
    var _f = (0, react_1.useState)(user.name), name = _f[0], setName = _f[1];
    var _g = (0, react_1.useState)(""), idNumberMessage = _g[0], setIDNumberMessage = _g[1];
    var _h = (0, react_1.useState)(""), nameMessage = _h[0], setNameMessage = _h[1];
    var _j = (0, react_1.useState)(""), emailMessage = _j[0], setEmailMessage = _j[1];
    var _k = (0, react_1.useState)(user.address), address = _k[0], setAddress = _k[1];
    var _l = (0, react_1.useState)(""), addressMessage = _l[0], setAddressMessage = _l[1];
    var _m = (0, react_1.useState)(), proofOfID = _m[0], setProofOfID = _m[1];
    var _o = (0, react_1.useState)(""), proofOfIDMessage = _o[0], setProofOfIDMessage = _o[1];
    var _p = (0, react_1.useState)(), proofOfResidence = _p[0], setProofOfResidence = _p[1];
    var _q = (0, react_1.useState)(""), proofOfResidenceMessage = _q[0], setProofOfResidenceMessage = _q[1];
    var _r = (0, react_1.useState)(0), idUploadProgress = _r[0], setIDUploadProgress = _r[1];
    var _s = (0, react_1.useState)(0), residenceUploadProgress = _s[0], setResidenceUploadProgress = _s[1];
    var _t = (0, react_1.useState)(""), cell_phone = _t[0], setCellPhone = _t[1];
    var _u = (0, react_1.useState)("ZA"), cc = _u[0], setCC = _u[1];
    var _v = (0, react_1.useState)(""), ext = _v[0], setExt = _v[1];
    var _w = (0, react_1.useState)(""), cellNumberMessage = _w[0], setCellNumberMessage = _w[1];
    var _x = (0, react_1.useState)(false), isLoading = _x[0], setIsLoading = _x[1];
    var _y = (0, react_1.useState)(null), auc = _y[0], setAuc = _y[1];
    (0, react_1.useEffect)(function () {
        (0, auctions_for_client_1.auctions_for_client)({
            entity_id: client_entity_id,
            user_entity_id: user === null || user === void 0 ? void 0 : user.entity_id,
        }).then(function (res) {
            setAuc(res === null || res === void 0 ? void 0 : res.content);
        });
    }, []);
    var validate = function () {
        var _a;
        var messageCount = 0;
        setIDNumberMessage("");
        setAddressMessage("");
        setProofOfIDMessage("");
        setProofOfResidenceMessage("");
        setCellNumberMessage("");
        if (!idNumber) {
            messageCount++;
            setIDNumberMessage("ID Number is required");
        }
        if (!name) {
            messageCount++;
            setNameMessage("Name is required");
        }
        if (!email) {
            messageCount++;
            setEmailMessage("Email is required");
        }
        if (!address) {
            messageCount++;
            setAddressMessage("Address is required");
        }
        if (!((_a = user.cell_phone) === null || _a === void 0 ? void 0 : _a.number)) {
            messageCount++;
            setCellNumberMessage("Cell Number is required");
        }
        else {
            console.log("user.cell_number", user.cell_phone.number);
            var isValid = doshx_controls_web_1.Utilities.isValidPhoneNumber(user.cell_phone.number, cc);
            console.log("isValid", isValid);
            if (!isValid) {
                messageCount++;
                setCellNumberMessage("Cell Number is invalid");
            }
        }
        if (!proofOfID) {
            messageCount++;
            setProofOfIDMessage("Proof of ID is required");
        }
        if (!proofOfResidence) {
            messageCount++;
            setProofOfResidenceMessage("Proof of Residence is required");
        }
        return messageCount === 0 ? true : false;
    };
    return (react_1.default.createElement("div", { className: "flex flex-col gap-4 h-full justify-center" },
        react_1.default.createElement("div", { className: "flex" },
            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Back", startIcon: pro_solid_svg_icons_1.faLeft, size: "xsmall", backgroundColor: "bg-secondary", onClick: function () {
                    dispatch((0, main_1.setDrawer)({
                        open: true,
                        content: react_1.default.createElement(auction_rules_conditions_1.AuctionRulesConditionsPage, null),
                    }));
                } })),
        react_1.default.createElement("div", { className: "flex flex-col gap-2" },
            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Register to Bid", size: "2xlarge", bold: true, textColor: "text-black" }),
            react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Full Name", value: name, onChange: function (v) {
                        setName(v);
                    }, errorText: nameMessage }),
                react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Email", value: email, onChange: function (v) {
                        setEmail(v);
                    }, errorText: emailMessage, disabled: !!((user === null || user === void 0 ? void 0 : user.token) || localStorage.getItem(local_storage_names_1.USER_LOCAL_STORAGE)) }),
                react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "ID Number", value: idNumber, onChange: function (v) {
                        setIDNumber(v);
                    }, errorText: idNumberMessage }),
                react_1.default.createElement(doshx_controls_web_1.PhoneInputControl, { label: "Phone Number", value: (_c = (_b = user.cell_phone) === null || _b === void 0 ? void 0 : _b.number) !== null && _c !== void 0 ? _c : "", defaultCountryCode: cc, size: "medium", onChange: function (v) {
                        setCellPhone(v);
                        dispatch((0, user_1.setUser)(__assign(__assign({}, user), { cell_phone: __assign(__assign({}, user.cell_phone), { number: v }) })));
                    }, onExtensionChange: function (ext, cc) {
                        setCC(cc);
                        setExt(ext);
                        dispatch((0, user_1.setUser)(__assign(__assign({}, user), { cell_phone: __assign(__assign({}, user.cell_phone), { country_code: cc, calling_code: ext }) })));
                    }, errorText: cellNumberMessage }),
                react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Address", value: address, onChange: function (v) {
                        setAddress(v);
                    }, errorText: addressMessage }),
                react_1.default.createElement("div", { className: "flex flex-col relative" },
                    react_1.default.createElement(doshx_controls_web_1.FileInputControl, { label: "Proof of ID", file: proofOfID, onChange: function (v) {
                            setProofOfID(v);
                        }, size: "medium", errorText: proofOfIDMessage }),
                    idUploadProgress < 100 && (react_1.default.createElement("div", { className: "h-2", style: {
                            width: "".concat(idUploadProgress, "%"),
                        } }))),
                react_1.default.createElement("div", { className: "flex flex-col relative" },
                    react_1.default.createElement(doshx_controls_web_1.FileInputControl, { label: "Proof of Residence", file: proofOfResidence, onChange: function (v) {
                            setProofOfResidence(v);
                        }, size: "medium", errorText: proofOfResidenceMessage }),
                    residenceUploadProgress < 100 && (react_1.default.createElement("div", { className: "h-2", style: {
                            width: "".concat(residenceUploadProgress, "%"),
                        } }))))),
        react_1.default.createElement("div", { className: "flex flex-row gap-4 justify-evenly w-full" },
            react_1.default.createElement("div", { className: "flex-1" },
                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Complete Registration", loading: isLoading, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var token, userEntityId, signUpResponse, loginResult;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    // if (validate()) {
                                    //   setIsLoading(true);
                                    if (!validate())
                                        return [2 /*return*/];
                                    setIsLoading(true);
                                    token = (user === null || user === void 0 ? void 0 : user.token) || localStorage.getItem(local_storage_names_1.USER_LOCAL_STORAGE);
                                    userEntityId = user === null || user === void 0 ? void 0 : user.entity_id;
                                    if (!!token) return [3 /*break*/, 5];
                                    return [4 /*yield*/, (0, sign_up_1.sign_up)({
                                            client_entity_id: client_entity_id,
                                            name: name,
                                            // surname: user?.surname ?? "",
                                            email: email,
                                            cell_phone: user === null || user === void 0 ? void 0 : user.cell_phone,
                                            // password: user?.password ?? "",
                                            // get_communication: user?.get_communication ?? false,
                                            // agrees_terms_and_conditions: user?.agrees_terms_and_conditions ?? false,
                                        })];
                                case 1:
                                    signUpResponse = _a.sent();
                                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 500); })];
                                case 2:
                                    _a.sent();
                                    return [4 /*yield*/, (0, sign_in_1.sign_in)({
                                            client_entity_id: client_entity_id,
                                            email: email,
                                        })];
                                case 3:
                                    loginResult = _a.sent();
                                    if (!loginResult.success) {
                                        setIsLoading(false);
                                        return [2 /*return*/];
                                    }
                                    token = loginResult.content.token;
                                    userEntityId = loginResult.content.user.entity_id;
                                    // ✅ 3️⃣ Save to localStorage
                                    localStorage.setItem(local_storage_names_1.USER_LOCAL_STORAGE, JSON.stringify({
                                        user: loginResult.content.user,
                                        token: token,
                                    }));
                                    dispatch((0, user_1.setUser)(__assign(__assign({}, loginResult.content.user), { token: loginResult.content.token })));
                                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 100); })];
                                case 4:
                                    _a.sent();
                                    token = loginResult.content.token;
                                    userEntityId = loginResult.content.user.entity_id;
                                    _a.label = 5;
                                case 5:
                                    (0, register_bidder_1.register_bidder)({
                                        id_number: idNumber,
                                        address: address,
                                        bidder: {
                                            client_entity_id: client_entity_id,
                                            user_entity_id: userEntityId,
                                            registered_auction_id: auctionId === null || auctionId === void 0 ? void 0 : auctionId.auctionId,
                                        },
                                        fullname: name,
                                        email: email,
                                        cell_phone: user.cell_phone,
                                    }).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    setIsLoading(false);
                                                    if (!response.success) return [3 /*break*/, 3];
                                                    setIsLoading(true);
                                                    return [4 /*yield*/, (0, upload_file_1.upload_file)({
                                                            bidder_entity_id: response.content.entity_id,
                                                            type: "Document",
                                                            custom_name: "proof_of_id",
                                                            file: proofOfID,
                                                            uploadProgress: function (percentCompleted) { return __awaiter(void 0, void 0, void 0, function () {
                                                                return __generator(this, function (_a) {
                                                                    setIDUploadProgress(percentCompleted);
                                                                    return [2 /*return*/];
                                                                });
                                                            }); },
                                                        }).then(function (response) {
                                                            setIsLoading(false);
                                                            console.log("response", response);
                                                            if (response.success) {
                                                                //
                                                            }
                                                            else {
                                                                dispatch((0, main_1.setMessageModal)({ title: "Something went wrong while uploading Proof of ID!", messages: [response.data.message] }));
                                                            }
                                                        })];
                                                case 1:
                                                    _a.sent();
                                                    setIsLoading(true);
                                                    return [4 /*yield*/, (0, upload_file_1.upload_file)({
                                                            bidder_entity_id: response.content.entity_id,
                                                            type: "Document",
                                                            custom_name: "proof_of_address",
                                                            file: proofOfResidence,
                                                            uploadProgress: function (percentCompleted) { return __awaiter(void 0, void 0, void 0, function () {
                                                                return __generator(this, function (_a) {
                                                                    setIDUploadProgress(percentCompleted);
                                                                    return [2 /*return*/];
                                                                });
                                                            }); },
                                                        }).then(function (response) {
                                                            setIsLoading(false);
                                                            if (response.success) {
                                                                //
                                                            }
                                                            else {
                                                                dispatch((0, main_1.setMessageModal)({ title: "Something went wrong while uploading Proof of Address!", messages: [response.data.message] }));
                                                            }
                                                        })];
                                                case 2:
                                                    _a.sent();
                                                    dispatch((0, bidder_1.setIsBidderRegistered)(true));
                                                    dispatch((0, main_1.setDrawer)({
                                                        open: false,
                                                    }));
                                                    (0, bidder_status_1.bidder_status)({
                                                        client_entity_id: client_entity_id,
                                                        user_entity_id: user.entity_id,
                                                        auction_entity_id: auctionId,
                                                    }).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                                                        var auctionResponse;
                                                        return __generator(this, function (_a) {
                                                            switch (_a.label) {
                                                                case 0:
                                                                    if (!response.success) return [3 /*break*/, 2];
                                                                    // dispatch(setIsBidderRegistered(response.content.is_registered));
                                                                    // dispatch(setIsBidderVerified(response.content.is_verified));
                                                                    // dispatch(setBidder(response.content.bidder));
                                                                    // dispatch(setIsBidderRegistered(true));
                                                                    // auctions_for_client({
                                                                    //   entity_id: client_entity_id,
                                                                    //   user_entity_id: user?.entity_id,
                                                                    // });
                                                                    dispatch((0, bidder_1.setIsBidderRegistered)(true));
                                                                    return [4 /*yield*/, (0, get_auction_1.get_auction)({
                                                                            entity_id: auctionId,
                                                                            user_entity_id: userEntityId,
                                                                        })];
                                                                case 1:
                                                                    auctionResponse = _a.sent();
                                                                    if (auctionResponse.success) {
                                                                        dispatch((0, auction_1.setAuction)(auctionResponse.content));
                                                                    }
                                                                    // 3. Close drawer
                                                                    dispatch((0, main_1.setDrawer)({ open: false }));
                                                                    // 4. Force reload if needed (temporary)
                                                                    dispatch((0, auction_1.setShouldReloadAuctions)(true));
                                                                    _a.label = 2;
                                                                case 2: return [2 /*return*/];
                                                            }
                                                        });
                                                    }); });
                                                    // dispatch(setShouldReloadAuctions(true));
                                                    window.location.reload();
                                                    return [3 /*break*/, 4];
                                                case 3:
                                                    dispatch((0, main_1.setMessageModal)({ title: "Something went wrong while saving details!", messages: [response.message] }));
                                                    _a.label = 4;
                                                case 4: return [2 /*return*/];
                                            }
                                        });
                                    }); });
                                    return [2 /*return*/];
                            }
                        });
                    }); }, backgroundColor: "bg-primary" })))));
};
exports.RegisterBidderComponent = RegisterBidderComponent;
